<template>
  <div class="page-container">
    <div class="wrap">
      <div v-if="loading" class="loading-wrap">
        <i class="el-icon-loading" />
      </div>
      <div v-else>
        <div class="page-title">{{$t('upgrade_page_views_dashboard_skills_skill_detail_1343', [gameInfo.name])}}</div>
        <div class="content-wrap">
          <div
            v-for="(m, i) in modelList"
            :key="'model-' + i"
            :is="m"
            :skillInfo="skillInfo"
            :gameInfo="gameInfo"
            @setSkillInfo="setSkillInfo"
          />
        </div>
      </div>
    </div>
    <div class="save-info-btn pointer" @click="saveSkillInfo">{{$t('upgrade_page_views_dashboard_skills_skill_detail_1344')}}</div>
  </div>
</template>
<script>
import i18n from '@/locales/index'

/** 價格設置 */
import SetPrice from './set-price'
/** 滿贈設置 */
import SetBuySend from './set-buy-send'
/** 屬性設置 */
import SetSkillProperty from './set-skill-property'
/** 需要審核的內容 */
import SkillSubmitCard from './skill-submit-card'
export default {
  components: {
    SetPrice,
    SetBuySend,
    SetSkillProperty,
    SkillSubmitCard,
  },
  data() {
    return {
      modelList: ['SetPrice', 'SetBuySend', 'SetSkillProperty', 'SkillSubmitCard'],
      gameInfo: null,
      skillInfo: null,
      loading: true,
    }
  },
  created() {
    Promise.all([this.getSkillInfo(), this.getGameInfo()])
      .then(() => {
        this.loading = false
      })
      .catch((e) => {
        console.log(e)
      })
  },
  methods: {
    setSkillInfo(info) {
      const obj = {}
      Object.assign(obj, this.skillInfo, info)
      this.skillInfo = obj
    },
    getGameInfo() {
      return this.$http.get('/player/skill/certification/gameinfo', {
        gameId: +(this.$route.query.gameId)
      }).then(({ data }) => {
        this.gameInfo = data
      })
    },
    getSkillInfo() {
      return this.$http.get('/player/skill/detail/info', {
        id: +(this.$route.query.skillId)
      }).then(({ data }) => {
        if (data.screenshotImageUrlList) {
          data.screenshotImageUrlList = JSON.parse(data.screenshotImageUrlList)
        } else {
          data.screenshotImageUrlList = []
        }
        this.skillInfo = data
      })
    },
    saveSkillInfo() {
      const { price, id, giveAwayList } = this.skillInfo
      if (!price) {
        this.$message(i18n.t('upgrade_page_views_dashboard_skills_skill_detail_1345'))
        return
      }
      if (this.submiting) return
      this.submiting = true
      if (giveAwayList) giveAwayList.forEach(item => item.skillId = id)
      const pro = (giveAwayList && giveAwayList.length) ? this.$http.post('/giveaway/batchAdd', giveAwayList) : this.$http.post('/giveaway/delBySkillId', { skillId: id })
      this.skillInfo.skillId = id
      Promise.all([this.$http.post('/player/skill/certification/save', this.skillInfo), pro])
        .then(() => {
          this.submiting = false
          this.$message.success(i18n.t('upgrade_page_views_dashboard_skills_skill_detail_1346'))
          this.$router.go(-1)
        })
        .catch(() => {
          this.submiting = false
          this.$message.error(i18n.t('upgrade_page_views_dashboard_skills_skill_detail_1347'))
        })
    }
  },
}
</script>
<style lang="scss" scoped>
  .page-title {
    padding: 24px 40px;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: $color-gray-1;
    border-bottom: 1px solid $color-split;
  }
  .content-wrap {
    padding: 10px 40px 100px;
    text-align: left;
  }
  .loading-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    height: 700px;
  }
  .page-container {
    margin: 40px auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .save-info-btn {
      margin-top: 40px;
      width: 200px;
      height: 54px;
      line-height: 54px;
      text-align: center;
      border-radius: 4;
      background: $color-yellow;
      font-weight: 500;
      font-size: 18px;
      color: $color-gray-1;
      &:hover {
        background: #F5CD23;
      }
    }
  }
  .wrap {
    width: 100%;
    border: 1px solid $color-split;
    box-sizing: border-box;
    border-radius: 8px;
    background: #fff;
    position: relative;
  }
</style>
